import { OPENING_INBOX, type Email } from './emails';

export interface OpeningState {
  emails: Email[];
}

export const OPENING_STATE: OpeningState = {
  emails: OPENING_INBOX,
};
